import React, { useState } from "react";

import people from "../../assets/people.png";
import SvgComponent from "../../components/SVGComponent/SVGComponent";
import "./Header.css";

const Header = () => {
  const [formValue, setFormValue] = useState("");

  console.log(formValue);

  return (
    <div className="header section__padding" id="home">
      <div className="header-content">
        <h1 className="gradient__text fade-in">Metamorph Your Business!</h1>
        <p className="fade-in">
          The internet is the most powerful tool in the 21st Century. One must
          not let it be in vain. Get your business online and evolve it into
          something bigger and better. Reap the benefits of an online reach.
        </p>

        <div className="header-content__input slide-in-fwd-left">
          <input
            type="email"
            placeholder="Your Email Address"
            value={formValue}
            onChange={(event) => setFormValue(event.target.value)}
          />
          <button type="button">Get Started</button>
        </div>

        <div className="header-content__people scale-up-center">
          <img src={people} />
          <p>Check out our reviews!</p>
        </div>
      </div>

      <div className="header-image">
        <SvgComponent />
      </div>
    </div>
  );
};

export default Header;
